module.exports = __webpack_public_path__ + "img/time-and-date.7073324d.svg";